


























import {Component, Vue} from 'vue-property-decorator'
import {namespace} from 'vuex-class'

import {RefundStatus,TaxRefund} from '@/store/modules/taxrefund/types'
import toCurrency from '@/filters/to-currency'
import {Bracket} from '@/icons'

const taxrefund = namespace('taxrefund')

@Component({
  components: {
    Bracket
  }
})
export default class RefundConfirmation extends Vue {
  @taxrefund.Getter('getRefundStatus') getRefundStatus: RefundStatus
  @taxrefund.State('taxrefund') taxrefund?: TaxRefund

  get conservativeTaxRefund(): number {
    const {refundPerYear} = this.taxrefund as TaxRefund
    const totalRefundAmount = Math.floor(refundPerYear.reduce((prev, curr) => curr.amount + prev, 0))
    return totalRefundAmount
  }

  toCurrencyValue(value, hasFilter?: boolean) {
    return toCurrency(value, hasFilter)
  }

  handleOpen() {
    if(this.getRefundStatus === RefundStatus.환급급신청) {
      this.$router.push({
        name: 'contract',
      }).catch((err) => err)
    } else {
      this.$router.push({
        name: 'taxrefund',
      }).catch((err) => err)
    }
  }
}
